import styled from 'styled-components';
import { InfoItem } from './MobileVehicleCard/useInfoItems';
import React from 'react';
import Tooltip from 'components/Tooltip';

const Wrapper = styled.div<{ withBorder: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex-grow: 1;
  ${props =>
    props.withBorder &&
    `
      border-right: 1px solid #00000033;
      padding-right: 4px;
    `};

  @media (min-width: 1200px) {
    justify-content: center;
    flex: 1 1 100%;
  }
`;

const Label = styled.div<{ highlighted?: boolean; size: 'sm' | 'lg' }>`
  font-size: ${props => (props.highlighted ? '12px' : '10px')};
  font-weight: ${props => (props.highlighted ? '500' : '400')};
  line-height: ${props => (props.highlighted ? '14px' : '11.72px')};
  color: rgba(117, 117, 117, 1);

  ${props =>
    props.size === 'lg' &&
    `
    font-size: 12px;
    `}
`;

const Value = styled.div<{ color?: string }>`
  font-size: ${props => (props.size === 'lg' ? '12px' : '12px')};
  font-weight: 500;
  line-height: ${props => (props.size === 'lg' ? '100%' : '14.06px')};
  color: ${props => props.color || '#000'};
  text-transform: capitalize;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 140px;
`;

const Row = styled.div<{ background?: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${props => props.background || 'transparent'};
  border-radius: 2px;
  padding: ${props => (props.background ? '0 4px' : '0')};
`;

type Props = { items: InfoItem[]; withBorder?: boolean; size?: 'sm' | 'lg' };

export const InfoComponent = ({ items, size = 'sm', withBorder = false }: Props) => {
  return (
    <Wrapper withBorder={withBorder}>
      {items.map(item => (
        <Row key={item.label} background={item.background}>
          <Label size={size} highlighted={item.highlighted}>
            {item.label}
          </Label>
          <Value size={size} color={item.color}>
            <WrappedValue value={item.value} />
          </Value>
        </Row>
      ))}
    </Wrapper>
  );
};

const WrappedValue = ({ value }: any) => {
  if (!value) return null;
  if (typeof value !== 'string') return value;

  return <ValueWithTooltip value={value} />;
};

const ValueWithTooltip: React.FC<{ value: string }> = ({ value }) => {
  return (
    <Tooltip fontSize="12px Roboto" title={value} maxWidth={150} arrow light>
      <span>{value}</span>
    </Tooltip>
  );
};
